import React from "react"
import { Button, Card, CardContent, CardHeader, Stack, Typography } from "@mui/material"
import { useNavigate } from "react-router";

function VobProductivityCard(){
    const navigate = useNavigate();
    return <React.Fragment>
    <Card sx={{width:'300px', position:'relative', overflow: 'visible'}}>
    <Button 
        variant='contained' 
        color="primary" 
        sx={{
            position: 'absolute', 
            bottom: '-15px', 
            right: '-15px', 
            backgroundColor:'#62BCBD',
            borderRadius: '20px',
        }} onClick={()=>navigate('/VOBProductivity')}>View</Button>
    <CardHeader title="VOB Productivity" sx={{backgroundColor:'#62BCBD', color:'white', height:'40px'}}/>
    <CardContent>
        <Stack direction="row" spacing={2}>
            <Typography variant="body1">Benefits and Authorization completed per user</Typography>
        </Stack>
    </CardContent>
    </Card>
    </React.Fragment>
}
export {VobProductivityCard}